import { useMutation } from "@tanstack/react-query";
import { Button, Modal, Radiobox, Typography } from "@weirgroup/weir-dls";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { AppConfigContext } from "../../contexts/app-config.context";
import { BasicModalType } from "../../types/basic-modal.type";
import { UserSettingType } from "../../types/user.type";
import userSettingsApi from "../../api/settings.api";
import "./styles.scss";
import { useDarkMode } from "../../hooks/use-darkmode";

export default function UnitsModal(props: Readonly<BasicModalType>) {
  const { t } = useTranslation();
  const appConfigStore = useContext(AppConfigContext);
  const [unitSelected, setUnitSelected] = useState(appConfigStore.units);
  const { mutateAsync, isLoading } = useMutation(userSettingsApi.updateUserSettings);
  const { toggleDialog, open } = props;
  const {darkMode} = useDarkMode()
  useEffect(() => {
    setUnitSelected(appConfigStore.units.toUpperCase() == "METRIC" ? "metric" : "imperial");
  }, [appConfigStore.units])

  const updateStore = async () => {
    appConfigStore.setUnits(unitSelected);
    const userSettings: UserSettingType = {
      language: appConfigStore.language,
      timezone: appConfigStore.timezone,
      units: unitSelected,
      asset_email_notification: appConfigStore.assetEmailNotification,
      geofence_email_notification: appConfigStore.geofenceEmailNotification,
      inapp_notification: appConfigStore.inAppNotification
    }
    await mutateAsync(userSettings);
    toggleDialog?.();
  };

  return (
    <Modal
      darkMode={darkMode}
      showModal={open}
      onClose={toggleDialog}
      size="small"
      dismissable
    >
      <Typography textAlign="center" variant="H4" color={darkMode ? "white": "black"}>{t("units")}</Typography>
        <div className="unit-container">
          <Radiobox
            darkMode={darkMode}
            name="units"
            label={t("metric")}
            value="metric"
            checked={unitSelected === "metric"}
            onChange={() => setUnitSelected("metric")}
            errorMessage=""
          />
          <Radiobox
            darkMode={darkMode}
            name="units"
            label={t("imperial")}
            value="imperial"
            checked={unitSelected === "imperial"}
            onChange={() => setUnitSelected("imperial")}
            errorMessage=""
          />
        </div>
      <div className="button-container">
        <Button
          darkMode={darkMode}
          label={t("set")}
          onClick={updateStore}
          isLoading={isLoading}
          disabled={isLoading}
        />
      </div>
    </Modal>
  );
}
